
import { useEffect, useState } from "react";
import WebsiteSubmissionForm from "./hero/WebsiteSubmissionForm";
import { PartnerLogos } from "./hero/PartnerLogos";
import { HeroHeader } from "./hero/HeroHeader";
import { HeroDescription } from "./hero/HeroDescription";
import { SchemaMarkup } from "./hero/SchemaMarkup";

export const Hero = () => {
  const [isGlowing, setIsGlowing] = useState(true);
  
  // Effect to create the flashing/glowing animation
  useEffect(() => {
    // Only animate for the first 10 seconds to avoid being too distracting
    const glowInterval = setInterval(() => {
      setIsGlowing(prev => !prev);
    }, 1500);
    
    const stopGlowing = setTimeout(() => {
      clearInterval(glowInterval);
      setIsGlowing(false);
    }, 10000);
    
    return () => {
      clearInterval(glowInterval);
      clearTimeout(stopGlowing);
    };
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center bg-brutal-white pt-24 pb-16 px-4">
      <div className="container mx-auto">
        <div className="max-w-4xl mx-auto text-center space-y-12 animate-fade-up py-8 md:py-12">
          <HeroHeader />
          
          <HeroDescription />

          <div className="bg-gradient-to-r from-brutal-white via-brutal-gray/20 to-brutal-white py-8 px-6 rounded-lg border-4 border-brutal-black transform -rotate-1 shadow-lg mx-auto">
            <WebsiteSubmissionForm />
          </div>

          <div className="mt-12">
            <PartnerLogos />
          </div>
        </div>
      </div>

      <SchemaMarkup />
    </section>
  );
};
